import React from 'react'

const SkillBlock = (props) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
      <div className="md:col-span-3 mb-2 md:mb-0">
        <div className="inline-flex rounded-full border border-white/10 bg-white/[0.03] px-4 py-2 text-sm font-semibold uppercase tracking-[0.2em] text-base-content/70 md:text-xs">
        {props.blockName}
        </div>
      </div>
      <div className="md:col-span-9">
        {props.children}
      </div>
    </div>
  )
}

export default SkillBlock
